import React from "react";
import Breadcrumb from "../../common/Breadcrumb";
import GuideWrap from "./GuideWrap";

function GuidePage() {
  return (
    <>
      <Breadcrumb name="Tour Guide" />
      <GuideWrap />
    </>
  );
}

export default GuidePage;
